// client/src/routes/app/properties/$propertyId/documents.tsx — SCR-PROP-003 tab „Documente" ·
// D-2575 (04 §8.3's tab set, „**Documente** (M3)").
//
// `Documents.Read` on top of the layout's `Portfolio.Read`: the tab lists the vault, which
// `DocumentsEndpoints` gates on it, so a membership that may see the flat but not its papers gets
// SCR-SYS-403 here rather than a tab that fails on its first request.

import { createFileRoute } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { ErrorState, LoadingState } from '@/components/ui/states';
import { PropertyDocumentsTab } from '@/features/documents/PropertyDocumentsTab';
import { useProperty } from '@/features/properties/queries';

export const Route = createFileRoute('/app/properties/$propertyId/documents')({
  component: DocumentsTabScreen,
});

function DocumentsTabScreen() {
  const { propertyId } = Route.useParams();
  const property = useProperty(propertyId);

  if (property.isPending) return <LoadingState rows={3} />;
  if (property.isError) {
    return <ErrorState error={property.error} onRetry={() => void property.refetch()} />;
  }

  return (
    <RequirePermission permission="Documents.Read">
      <PropertyDocumentsTab propertyId={propertyId} propertyName={property.data.general.name} />
    </RequirePermission>
  );
}
